module.exports = __webpack_public_path__ + "static/media/draw-searching.5863de27.svg";